import './main-bootstrap.css'
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Header from './componentes/Header';
import Footer from './componentes/Footer';
import Menu from './componentes/Menu';

import Rotas from './rotas/Rotas';
import AuthProvider from './contextos/authContext';
import GlobalStyle from './globalStyles';
import { Helmet } from 'react-helmet';

import './config/configLog'

function App() {

  return (
    <div className="app">
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&family=Prosto+One&family=Protest+Riot&family=Kanit&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <GlobalStyle />
        <Header />
        <Toaster />
        <main className='container-pagina'>
          <AuthProvider> {/* Esse cara aqui controla e verifica se o usuário está logado */}
            <Menu />
            <Rotas />
          </AuthProvider>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
